export const SET_SELECTED_INFO_VALUE = "@SET_SELECTED_INFO_VALUE";
export const SET_QUESTIONS_DATA = "@SET_QUESTIONS_DATA";
export const SET_SELECTED_QUESTION_KEY = "@SET_SELECTED_QUESTION_KEY";
export const FETCH_QUESTIONS_DATA = "@FETCH_QUESTIONS_DATA";
export const SET_QUESTIONS_LOADING = "@SET_QUESTIONS_LOADING";
export const ONBOARDING__TOGGLE_WELCOME_MODAL =
  "@ONBOARDING__TOGGLE_WELCOME_MODAL";
export const ONBOARDING__TOGGLE_BONUS_MODAL = "@ONBOARDING__TOGGLE_BONUS_MODAL";
export const SET_FETCH_QUESTIONS_DATA_LOADER =
  "@SET_FETCH_QUESTIONS_DATA_LOADER";
